import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorPageTemplate } from 'swo-ciam-common-react';

import { LocaleTranslationKeysEnum } from '@src/core/i18n/locale-translation-keys.enum';
import image from '../../../../../public/images/500.png';
import { RoutePathsEnum } from '../../route-paths.enum';

const Error500Component = () => {
  const navigate = useNavigate();

  const buttonClickHandler = useCallback(() => navigate(-1), [navigate]);

  return (
    <ErrorPageTemplate
      items={[
        { key: LocaleTranslationKeysEnum.SwoErrorPages500Title },
        {
          key: LocaleTranslationKeysEnum.SwoErrorPages500SubTitle,
        },
        {
          key: LocaleTranslationKeysEnum.SwoErrorPages500Description,
        },
      ]}
      link={{ external: false, url: RoutePathsEnum.Home }}
      image={{ src: image, alt: LocaleTranslationKeysEnum.SwoErrorPages500ImgAlt }}
      button={{
        label: LocaleTranslationKeysEnum.SwoErrorPagesSharedActionsGoBack,
        placeholder: LocaleTranslationKeysEnum.SwoErrorPagesSharedActionsGoBack,
        onClick: buttonClickHandler,
      }}
      footerText={{
        key: LocaleTranslationKeysEnum.SwoErrorPagesSharedFooterText,
      }}
    />
  );
};

export default Error500Component;
